<template>
  <div class="list-item" :style="listItemStyle">
    <div class="list-item__main">
      <lego-checkbox v-if="check != undefined" v-model="check2" class="list-item__check" />
      <lego-radio v-else-if="radio != undefined" v-model="radio2" class="list-item__check" />
      <!--
                $ver: v0.1.0
                <em>lego-list</em> 컴포넌트로 표현되는 리스트 목록의 내부 영역입니다.
                #The internal area of ​​the list of lists represented by the <em>lego-list</em> component.
            -->
      <slot />
      <div v-if="expandable" class="list-item__support">
        <lego-icon v-if="isExpend" sm @click="toggleExpand">collapse_menu</lego-icon>
        <lego-icon v-else sm @click="toggleExpand">expand_menu</lego-icon>
      </div>
    </div>
    <div v-if="isExpend" class="list-item__expand">
      <!--
                $ver: v0.1.3
                <em>expandable</em> 기능 사용 시 펼쳐지는 부분의 컨텐츠 영역입니다.
                #The content area of ​​the expanded portion of the <em>expandable</em> feature.
            -->
      <slot name="expand" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'legoListItem',
  props: {
    // $ver: v0.1.3
    // 리스트 컴포넌트의 너비 입니다. 숫자로 입력하면 'px' 단위, 문자열로 '00px' 또는 '00%' 형태로 입력할 수 있습니다.
    // # The width of the list component. If you enter a number, you can enter it in 'px' units, or as a string '00px' or '00% '.
    width: { type: [Number, String], default: undefined },
    // $ver: v0.1.3
    // 리스트 컴포넌트의 높이 입니다. 숫자로 입력하면 'px' 단위, 문자열로 '00px' 또는 '00%' 형태로 입력할 수 있습니다.
    // # The height of the list component. If you enter a number, you can enter it in 'px' units, or as a string '00px' or '00% '.
    height: { type: [Number, String], default: undefined },
    // $ver: v0.1.3
    // 라디오 컨트롤을 사용합니다. 데이터 바인딩하여 활용합니다.
    // # The value bound to the radio control.
    radio: { default: undefined },
    // $ver: v0.1.3
    // 체크박스 컨트롤을 사용합니다. 데이터 바인딩하여 활용합니다.
    // # The value bound to the radio control.
    check: { default: undefined },
    // $ver: v0.1.3
    // Expand 기능을 활성화 합니다. 리스트 우측의 펼침/닫힘 버튼으로 동작합니다.
    // 펼쳤을 때 보여지는 컨텐츠는 <em>expand</em> 슬롯으로 작성하면 됩니다.
    // # The value bound to the radio control.
    expandable: { type: Boolean, default: false },
  },
  data() {
    return {
      isExpend: false,
      check2: this.check,
      radio2: this.radio
    };
  },
  computed: {
    listItemStyle() {
      var style = {};
      var width, height;

      if (this.width) {
        if (isNaN(this.width)) {
          width = this.width;
        } else {
          width = this.width + 'px';
        }
        style['width'] = width;
      }

      if (this.height) {
        if (isNaN(this.height)) {
          height = this.height;
        } else {
          height = this.height + 'px';
        }
        style['height'] = height;
      }

      return style;
    },
  },
  methods: {
    toggleExpand() {
      this.isExpend = !this.isExpend;
    },
  },
};
</script>
